<div id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
     aria-hidden="true">
    <div class="" role="document">
        <div class="modal-content" style="border: none !important;">
            <div class="modal-header py-0">
                <h2 class="modal-title" id="exampleModalLongTitle">{{modalTitle}}</h2>

            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <form [formGroup]="form">
                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Naziv* </label>
                            <div class="col-sm-8">
                                <input type="text" formControlName="name" class="form-control"
                                       placeholder="Unesite naziv boarda">
                                <div *ngIf="!form.get('name').valid && form.get('name').touched">
                                    <span class="text-danger"> Ovo polje je obavezno.</span>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Tagovi </label>
                            <div class="col-sm-8">
                                <app-choose-tags (outputToParent)="getHashesHandler($event)"
                                                 [style]="'border:1px solid #80808057;border-radius:4px'"></app-choose-tags>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Projekat </label>
                            <div class="col-sm-8">
                                <app-select-project (outputToParent)="getProjectHandler($event)"></app-select-project>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <label class="col-sm-4 col-form-label">Tip* </label>
                            <div class="col-sm-8">
                                <div class="form-check">
                                    <input class="form-check-input"
                                           type="radio"
                                           value="kanban"
                                           formControlName="type"
                                           id="kanbanRadioDefault">
                                    <label class="form-check-label" for="kanbanRadioDefault">
                                        Kanban
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input"
                                           type="radio"
                                           formControlName="type"
                                           value="scrum"
                                           id="scrumRadioDefault">
                                    <label class="form-check-label" for="scrumRadioDefault">
                                        Scrum
                                    </label>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button (click)="closeModal()" type="button" class="btn btn-light" data-dismiss="modal">Zatvori
                </button>
                <button (click)="addNewBoard()" type="button" class="btn btn-primary">Sačuvaj</button>
            </div>
        </div>
    </div>
</div>







